export const resources = {
  ADD_BUILDING: {
    VIEW: "ADD_BUILDING.VIEW",
  },
  BUILDING_PROFILE: {
    DELETE_FILE: "BUILDING_PROFILE.DELETE_FILE",
    DOWNLOAD_FILES: "BUILDING_PROFILE.DOWNLOAD_FILES",
    THREE_D_VIEWER: "BUILDING_PROFILE.THREE_D_VIEWER",
    UPLOAD_FILES: "BUILDING_PROFILE.UPLOAD_FILES",
    UPLOAD_IMAGE: "BUILDING_PROFILE.UPLOAD_IMAGE",
  },
  CERTIFICATE: {
    DOWNLOAD_FILES: "CERTIFICATE.DOWNLOAD_FILES",
  },
  ENERGY_PERFORMANCE: {
    DOWNLOAD_FILES: "ENERGY_PERFORMANCE.DOWNLOAD_FILES",
  },
  EXECUTION: {
    RUN: "EXECUTION.RUN",
    VIEW: "EXECUTION.VIEW",
  },
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS",
  MODERNIZATION: {
    CUSTOM_SCENARIO_UPLOAD: "MODERNIZATION.CUSTOM_SCENARIO_UPLOAD",
    DOWNLOAD_SCENARIOS: "MODERNIZATION.DOWNLOAD_SCENARIOS",
  },
  TECHNICAL_DATA: {
    DOWNLOAD_FILES: "TECHNICAL_DATA.DOWNLOAD_FILES",
    EDIT_TABLE_CELL: "TECHNICAL_DATA.EDIT_TABLE_CELL",
    REMOVE_ROW: "TECHNICAL_DATA.REMOVE_ROW",
    SELECT_COLUMNS: "TECHNICAL_DATA.SELECT_COLUMNS",
    UPLOAD_FILES: "TECHNICAL_DATA.UPLOAD_FILES",
  },
};
